// All available agents (sync with AIAgentSelector.tsx, minus web-action)
import video_summary_agent from '@/assets/video_summary_agent.png';
import ppt_agent from '@/assets/ppt_agent.png';
import recipe_agent from '@/assets/reciepe_agent.png';
import qr_agent from '@/assets/qr_code_agent_icon.png';
import unit_conv_agent from '@/assets/unit_con_agent_icon.png';
import password_agent from '@/assets/password_agent_icon.png';
import color_palette_agent from '@/assets/color_pallete_agent.png';
import code_agent from '@/assets/code_agent_icon.png';
import meme_agent from '@/assets/meme_agent_icon.png';


export const ALL_AGENTS: AIAgent[] = [
  {
    id: 'weather',
    name: 'Weather',
    description: 'Current weather',
    icon: 'https://cdn-icons-png.freepik.com/512/6421/6421078.png',
    category: 'Utility',
  },
  {
    id: 'search',
    name: 'Google',
    description: 'Google search',
    icon: 'https://upload.wikimedia.org/wikipedia/commons/thumb/3/3c/Google_Favicon_2025.svg/960px-Google_Favicon_2025.svg.png',
    category: 'Search',
  },
  {
    id: 'wikipedia',
    name: 'Wikipedia',
    description: 'Wiki articles',
    icon: 'https://upload.wikimedia.org/wikipedia/commons/6/63/Wikipedia-logo.png',
    category: 'Information',
  },
  {
    id: 'youtube',
    name: 'YouTube',
    description: 'YouTube search',
    icon: 'https://upload.wikimedia.org/wikipedia/commons/e/ef/Youtube_logo.png?20220706172052',
    category: 'Entertainment',
  },
  {
    id: 'giphy',
    name: 'Giphy',
    description: 'GIF search',
    icon: 'https://www.cdnlogo.com/logos/g/34/giphy.svg',
    category: 'Entertainment',
  },
  {
    id: 'meme',
    name: 'MemeGen',
    description: 'Create memes',
    icon: meme_agent,
    category: 'Entertainment',
  },
  // {
  //   id: 'translator',
  //   name: 'Translator',
  //   description: 'Text translate',
  //   icon: 'https://upload.wikimedia.org/wikipedia/commons/d/db/Google_Translate_Icon.png',
  //   category: 'Utility',
  // },
  // {
  //   id: 'calculator',
  //   name: 'Calculator',
  //   description: 'Math solve',
  //   icon: 'https://cdn2.iconfinder.com/data/icons/ios7-inspired-mac-icon-set/512/Calculator_512.png',
  //   category: 'Utility',
  // },
  // {
  //   id: 'news',
  //   name: 'News',
  //   description: 'Latest news',
  //   icon: 'https://cdn-icons-png.flaticon.com/512/321/321680.png',
  //   category: 'Information',
  // },
  {
    id: 'code',
    name: 'Code',
    description: 'Explain/Create/fix code',
    icon: code_agent,
    category: 'Development',
  },
  {
    id: 'recipe',
    name: 'Recipe',
    description: 'Find recipes',
    icon: recipe_agent,
    category: 'Lifestyle',
  },
  {
    id: 'qr-code',
    name: 'QR Code',
    description: 'Make QR code',
    icon: qr_agent,
    category: 'Utility',
  },
  {
    id: 'color-palette',
    name: 'Palette',
    description: 'Color palette',
    icon: color_palette_agent,
    category: 'Design',
  },
  {
    id: 'pixabay',
    name: 'Pixabay',
    description: 'Free images',
    icon: 'https://cdn-icons-png.flaticon.com/256/3670/3670006.png',
    category: 'Images',
  },
  {
    id: 'wiki-images',
    name: 'Wiki Images',
    description: 'Wikimedia Commons Images',
    icon: 'https://upload.wikimedia.org/wikipedia/commons/4/4a/Commons-logo.svg',
    category: 'Images',
  },
  {
    id: 'video-summary',
    name: 'Video Summariser',
    description: 'Summarize video',
    icon: video_summary_agent,
    category: 'Information',
  },
  {
    id: 'SlidesAi',
    name: 'SlidesAi',
    description: 'Generate presentation slides',
    icon: ppt_agent,
    category: 'Creation',
  },
  {
    id: 'flow',
    name: 'FlowChart',
    description: 'Create flowcharts',
    icon: 'https://res.cloudinary.com/dx0aqgtyg/image/upload/v1767364179/c48f685a-28ae-43c5-a180-e1ac9de46682_tnwnio.png',
    category: 'Development',
  },
];

export interface MemeTemplate {
  id: string;
  name: string;
  url: string;
  width: number;
  height: number;
  box_count: number;
}

export interface GiphyGif {
  id: string;
  title: string;
  url: string;
  preview: string;
  downloadUrl: string;
}

export interface AgentResult {
  type?: 'meme_templates' | 'giphy_results' | 'web_navigate' | 'web_search' | 'web_click' | 'web_screenshot' | 'web_scroll' | 'web_describe' | 'web_extract' | 'web_error';
  templates?: MemeTemplate[];
  gifs?: GiphyGif[];
  query?: string;
  message?: string;
  success?: boolean;
  url?: string;
  topText?: string;
  bottomText?: string;
  error?: string;
  screenshotUrl?: string;
}

export interface AIAgent {
  id: string;
  name: string;
  description: string;
  icon: string;
  category: string;
}

export interface AttachedMedia {
  type: 'image' | 'video' | 'document';
  url: string;
  name?: string;
  file?: File;
  originalExt?: string;
  pageCount?: number;
  convertedImageUrls?: string[];
  parsedContent?: {
    html: string;
    markdown: string;
    text: string;
  };
  uploading?: boolean;
  uploadError?: string;
}
